import React from 'react';
import { Footer } from "flowbite-react";

const CustomFooter = () => {
    return (            
        <Footer container className="w-full text-center mt-auto">
            <div className="w-full">
                <Footer.Copyright 
                    href="https://chat.whatsapp.com/Dmuir2XzvuhKBrhnuqD1nW" 
                    by="Nigerian Competitive Programming Community" 
                    year={2024} 
                />
            </div>
        </Footer>
    );
};

export default CustomFooter;
